import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import QuoteForm from './QuoteForm';

const CTASection = () => {
  return (
    <section id="proposal" className="py-24 lg:py-28 bg-[#08080a] scroll-mt-24">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-start">
          <div>
            <p className="section-label mb-4">Ready to grow?</p>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-[1.05] mb-6">
              Request a bespoke proposal for how we can fix your problems. <span className="text-[#F5CD1B]">Sent within 48 hours.</span>
            </h2>
            <p className="text-white/70 text-lg leading-relaxed mb-4">
              Fill out the form to be sent your bespoke proposal (written by one of Yellow's directors) for our solutions to your specific issue. Or if you just want to discuss your project please feel free to call <a href="tel:01514272900" className="text-white font-semibold hover:text-[#F5CD1B]">0151 427 2900</a>.
            </p>
            <p className="text-white/60 text-sm">
              We are based in <span className="text-white font-semibold">Liverpool</span> but cover the <span className="text-white font-semibold">whole UK</span>.
            </p>
            <Link to="/contact" className="mt-8 inline-flex items-center gap-2 text-[#F5CD1B] font-semibold group">
              View full contact page <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
            </Link>
          </div>
          <QuoteForm source="Quote form (CTA)" />
        </div>
      </div>
    </section>
  );
};

export default CTASection;
